import ReactSelect, { GroupBase, Props, StylesConfig } from 'react-select'

const typeaheadStyles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? 'red' : baseStyles.borderColor,
    boxShadow: state.isFocused ? '0 0 0 1px red' : baseStyles.boxShadow,
    '&:hover': state.isFocused ? 'red' : baseStyles[':hover'],
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected
      ? 'var(--accent-indicator)'
      : state.isFocused
        ? 'var(--focus-a5)'
        : '',
    color: state.isSelected ? 'white' : baseStyles.color,
  }),
}

export function Typeahead<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  return (
    <ReactSelect<Option, IsMulti, Group>
      {...props}
      styles={{ ...typeaheadStyles, ...props.styles } as StylesConfig<Option, IsMulti, Group>}
    />
  )
}
